import { appStore } from '../../store';

class SyncroLogger {
  private oneTimers = new Set<SyncroLogEvent>();
  private times = new Map<SyncroLogEvent, number>();

  track(
    event: SyncroLogEvent,
    params?: Record<string, any>,
    options?: TrackOptions,
  ) {
    const app = appStore;
    const { timeSince } = options || ({} as TrackOptions);

    let eventParams: Record<string, any> = {
      channel: app.connection.rtcAvailable ? 'WebRTC' : 'WebSockets',
      ...params,
    };

    // Get rid off reassignment
    if (timeSince && this.times.has(timeSince))
      eventParams = {
        ...eventParams,
        [`time_since_${timeSince}`]: getSeconds(
          performance.now() - this.times.get(timeSince),
        ),
      };

    this.times.set(event, performance.now());

    // todo: log to somewhere (was mixpanel before)
  }

  trackOnetime(
    evt: SyncroLogEvent,
    params?: Record<string, any>,
    options?: TrackOptions,
  ) {
    if (this.oneTimers.has(evt)) {
      console.debug(`event ${evt} already happened, doing nothing`);
      return;
    }

    this.oneTimers.add(evt);

    // todo: log to somewhere (was mixpanel before)
  }
}

const getSeconds = (ms: number) => ms / 1000;

export const logger = new SyncroLogger();

type TrackOptions = {
  timeSince?: SyncroLogEvent;
};

type SyncroLogEvent =
  | 'app_load'
  | 'app_connected'
  | 'app_unload'
  | 'left_menu_nav'
  | 'webrtc_opened'
  | 'webrtc_connected'
  | 'webrtc_closed'
  | 'screenshare_connected'
  | 'screenshare_connect_click'
  | 'channel_status'
  | 'remote_host_not_found';
